//@flow

import React, { Component, Fragment } from 'react';
import { Modal, Form, ModalBody, Button } from 'reactstrap';

import config from '../../config';
import FormState from './FormState';
import GoogleLogin from './GoogleLogin';
import FacebookLogin from './FacebookLogin';

type Props = {
  login: boolean,
  serverError: string,
  loading: boolean,
  requestLogin: Function,
  clearServerError: () => void,
  closeAuthModal: () => void,
  closeNestedModal: () => void,
  registerAccount: () => void,
  openSignUpModal: () => void,
  openLoginModal: () => void,
  isSignUp: boolean,
};

type State = { showForm: boolean };

export default class LoginModal extends Component<Props, State> {
  hgLogo = `${config.ASSETS_URL}/logo.png`;

  styles = { modal: { maxWidth: '360px' } };

  form = {
    headerText: {
      signup: 'Get the Best out of your Trek with one Insight a Day',
      login: 'Get the Best out of your Trek with one Insight a Day',
    },

    buttonText: {
      signup: 'Sign up with Email and Password',
      login: 'Login  with Email and Password',
    },

    belowButtonText: {
      signup: 'Already a member?',
      login: 'Not a member',
    },

    belowButtonLinks: {
      signup: 'Log In',
      login: 'Create an account',
    },

    facebook: {
      signup: 'Sign up with Facebook',
      login: 'Login with Facebook',
    },

    google: {
      signup: 'Sign up with Google',
      login: 'Login with Google',
    },
  };

  state = { showForm: false };

  render() {
    const { showForm } = this.state;
    const {
      login,
      loading,
      requestLogin,
      serverError,
      registerAccount,
      isSignUp,
    } = this.props;

    const {
      headerText,
      buttonText,
      belowButtonLinks,
      belowButtonText,
      facebook,
      google,
    } = this.form;

    const authType = isSignUp ? 'signup' : 'login';

    const Facebook = (
      <FacebookLogin
        key="facebook"
        submit={isSignUp ? registerAccount : requestLogin}
        loading={loading}
        buttonText={facebook[authType]}
      />
    );

    const Google = (
      <GoogleLogin
        key="google"
        submit={isSignUp ? registerAccount : requestLogin}
        loading={loading}
        buttonText={google[authType]}
      />
    );

    const Signup = (
      <FormState
        isSignUpForm={isSignUp}
        submit={registerAccount}
        loading={loading}
        loadingTextIndicator="JOINING"
        buttonText="JOIN HONEYGUIDE"
        clearServerError={this.clearServerError}
      />
    );

    const Login = (
      <FormState
        isSignUpForm={isSignUp}
        submit={requestLogin}
        loading={loading}
        loadingTextIndicator="LOGGING IN"
        buttonText="LOGIN"
        clearServerError={this.clearServerError}
      />
    );

    const authForm = (
      <Form className="auth-form">
        <div className="error">{serverError}</div>
        {isSignUp ? Signup : Login}
      </Form>
    );

    const formButton = (
      <Button
        key="formButton"
        onClick={this.onShowForm}
        color="primary"
        className="btn-login btn-sign btn-fw"
      >
        {buttonText[authType]}
      </Button>
    );

    return (
      <Modal
        isOpen={login}
        toggle={this.closeModal}
        className="login-modal"
        style={this.styles.modal}
      >
        <ModalBody>
          <button
            type="button"
            className="closeModal"
            aria-label="Close"
            onClick={this.closeModal}
          >
            <span aria-hidden="true">×</span>
          </button>
          <div className="login-holder">
            <div className="form">
              <div className="greeting">
                <div className="logo">
                  <img src={this.hgLogo} alt="HoneyGuide Logo" />
                </div>
                <h1>{headerText[authType]}</h1>
              </div>

              <div className="login-action">
                {showForm ? (
                  <Fragment>{[authForm, Facebook, Google]}</Fragment>
                ) : (
                  <Fragment>{[Facebook, Google, formButton]}</Fragment>
                )}
                <p className="form-toggle">
                  {belowButtonText[authType]}{' '}
                  <a onClick={this.toggleSignup}>{belowButtonLinks[authType]}</a>
                </p>
              </div>
              <div className="message">
                <p className="mt-3 mb-1">Trusted by Over 18,000 trekkers &</p>
                <ul className="trust-img">
                  <li>
                    <img
                      src="https://s3.amazonaws.com/honeyguide/assets/lp-white.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      src="https://s3.amazonaws.com/honeyguide/assets/wb-white.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      src="https://s3.amazonaws.com/honeyguide/assets/slush-white.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      src="https://s3.amazonaws.com/honeyguide/assets/bw-white.png"
                      alt=""
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    );
  }

  onShowForm = () => this.setState({ showForm: true });

  hideForm = () => {
    if (this.state.showForm) this.setState({ showForm: false });
  };

  closeModal = () => {
    const { closeAuthModal, closeNestedModal } = this.props;

    closeAuthModal();

    //not checking whether the nested modal is opened or not
    //since any nested modal opening will
    //update this component causing unnecessary render.
    setTimeout(() => closeNestedModal(), 500);

    this.clearServerError();
    this.hideForm();
  };

  toggleSignup = () => {
    this.clearServerError();
    clearTimeout();
    setTimeout(this.toggleForm, 300);
  };

  toggleForm = () => {
    const { openSignUpModal, openLoginModal, isSignUp } = this.props;
    return isSignUp ? openLoginModal() : openSignUpModal();
  };

  clearServerError = () => {
    const { serverError, clearServerError } = this.props;
    if (serverError) clearServerError();
  };

  componentWillUnmount() {
    clearTimeout();
  }
}



// WEBPACK FOOTER //
// ./src/components/Login/LoginModal.jsx